// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_g4-0";
export var fulfillmentPanelBody = "_g4-1";